import { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals/ModalComponent";
import { Form, Input } from "antd";
import LoadableButton from "../../../components/button/LoadableButton";
import { editEmployeeApi } from "../../../api/request/team";
import toast from "react-hot-toast";

const EditUserDetailModal = ({
  selectedEmployee,
  editInformation,
  setEditInformation,
  getTeamList,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const params = {
        ...values,
        id: selectedEmployee?.id,
      };
      if (!values.password) {
        delete params.password;
      }

      const { data } = await editEmployeeApi(params);
      if (data?.status) {
        toast.success(data?.message);
        setEditInformation(false);
        if (getTeamList) getTeamList();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (editInformation && selectedEmployee) {
      form.setFieldsValue({
        first_name: selectedEmployee?.name?.split(" ")[0] || "",
        last_name: selectedEmployee?.name?.split(" ")[1] || "",
        email: selectedEmployee?.email || "",
        password: "",
      });
    }
  }, [selectedEmployee, editInformation, form]);

  useEffect(() => {
    if (!editInformation) form.resetFields();
  }, [editInformation, form]);

  return (
    <ModalComponent
      isOpen={editInformation}
      setIsOpen={setEditInformation}
      title="Edit Profile"
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        size="large"
        autoComplete="off"
        onFinish={handleSubmit}
      >
        <div className="grid lg:grid-cols-2 gap-4">
          <Form.Item
            name="first_name"
            label="First Name"
            rules={[{ required: true, message: "Please enter first name." }]}
          >
            <Input placeholder="First name" />
          </Form.Item>

          <Form.Item
            name="last_name"
            label="Last Name"
            rules={[{ required: true, message: "Please enter last name." }]}
          >
            <Input placeholder="Last name" />
          </Form.Item>
        </div>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: "Please enter email." },
            { type: "email", message: "Please enter a valid email." },
          ]}
        >
          <Input placeholder="Email" />
        </Form.Item>

        <Form.Item
          name="password"
          label="Password"
          rules={[
            {
              min: 8,
              message: "Password must be at least 8 characters",
              transform: (value) => (value ? value : undefined),
            },
          ]}
        >
          <Input.Password placeholder="Leave blank to keep current password" />
        </Form.Item>

        <div className="text-center mt-5">
          <LoadableButton
            type="submit"
            lable="Submit"
            isLoading={isLoading}
            loadingLable="Updating Profile..."
          />
        </div>
      </Form>
    </ModalComponent>
  );
};

export default EditUserDetailModal;
